"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesHelper = void 0;
var fs = __importStar(require("fs"));
var CommonTypesHelper_1 = require("./CommonTypesHelper");
var TypesHelper = /** @class */ (function () {
    function TypesHelper() {
    }
    TypesHelper.loadTypeDefs = function () {
        var loc = "".concat(__dirname, "/schemas/policy-admin-graphql");
        return __spreadArray(__spreadArray([], CommonTypesHelper_1.CommonTypesHelper.loadTypeDefs(), true), [
            fs.readFileSync("".concat(loc, "/CommissionRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CommissionResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PolicyInfoRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PolicyInfoResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/LoanResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/LoanRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PolicyBeneficiaryInfoRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/PolicyBeneficiaryInfoResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RefreshElasticSearchRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RefreshElasticSearchResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/IssueAnnuityRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/IssueAnnuityResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AdhocAnnuityTrancheRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/AdhocAnnuityTrancheResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelTrancheRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelTrancheResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/schema.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateCollectionSettingsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateCollectionSettingsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelCollectionSettingsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelCollectionSettingsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RetryFailedAnnuityPaymentRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/RetryFailedAnnuityPaymentResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityPaymentInformationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityPaymentInformationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityOwnerRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityOwnerResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuitantRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuitantResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CommonInputSchemas.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityBeneficiariesRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateAnnuityBeneficiariesResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ChangeAnnuitizationDateAndPayoutAmountRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ChangeAnnuitizationDateAndPayoutAmountResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetAnnuityPolicyRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetAnnuityPolicyResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDocumentsRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDocumentsResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetScheduledChangePaymentDateRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetScheduledChangePaymentDateResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelScheduledChangePaymentDateRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelScheduledChangePaymentDateResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetAnnuityScheduledChangeRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetAnnuityScheduledChangeResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GeneratePolicyPacketRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetUpdatePaymentFrequencyQuoteRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GeneratePolicyPacketResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/InitialInvoiceRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/InitialInvoiceResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdatePaymentInformationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdatePaymentInformationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/IssueDisabilityRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/IssueDisabilityResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityOwnerRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityOwnerResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityInsuredRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityInsuredResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityBeneficiariesRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/UpdateDisabilityBeneficiariesResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelDisabilityPolicyRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CancelDisabilityPolicyResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProcessDisabilityClaimRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/ProcessDisabilityClaimResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDisabilityPolicyStatusRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetUpdatePaymentFrequencyQuoteResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDisabilityPolicyStatusResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetPolicyDocResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetPolicyDocRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetPolicyRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/WholeLifeInforceIllustrationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityChangeBenefitAmountRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/DisabilityChangeBenefitAmountResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/TermIllustrationRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/TermIllustrationResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDisabilityReinstatementQuoteRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/GetDisabilityReinstatementQuoteResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/InitiateDisabilityReinstatementRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/InitiateDisabilityReinstatementResponse.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CheckDisabilityDiscountEligibilityRequest.graphql"), 'utf8'),
            fs.readFileSync("".concat(loc, "/CheckDisabilityDiscountEligibilityResponse.graphql"), 'utf8'),
        ], false);
    };
    return TypesHelper;
}());
exports.TypesHelper = TypesHelper;
//# sourceMappingURL=TypesHelper.js.map